import {log} from "../../hooks/useAmplitude";
import {
  LOG_EVENT_SIGN_IN_CLICKED,
  LOG_EVENT_SIGN_IN_OTHER_SIGN_IN_LINK_CLICKED,
  LOG_EVENT_SIGN_IN_SSO_GO_CLICKED,
  LOG_EVENT_SIGN_IN_VIEWED,
} from "./constants";
export const logSignInViewed = () => {
  log(LOG_EVENT_SIGN_IN_VIEWED);
};

export const logSignInClicked = () => {
  log(LOG_EVENT_SIGN_IN_CLICKED);
};

export const logSignInSSOGoClicked = ({ org }) => {
  log(LOG_EVENT_SIGN_IN_SSO_GO_CLICKED, { org });
};

export const logSignInOtherLink = ({ link }) => {
  log(LOG_EVENT_SIGN_IN_OTHER_SIGN_IN_LINK_CLICKED, { link });
};
